module.exports = __webpack_public_path__ + "encs/web_store/avpv/img/woa-chatgroup.251524f2.svg";